import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import {highlightGeojson} from "../actions/geojson_actions";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import AddIcon from "@material-ui/icons/Add";
import ListSubheader from "@material-ui/core/ListSubheader";


class GeoJSONSelector extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            currentValue: "No area selected",
            hovered: false,
        } ;
    }

    highlight = (geojson) => {
        this.props.highlightBoundary(geojson.id, true)
        this.setState({
            hovered: true,
        })
    }

    lowlight = (geojson) => {
        this.props.highlightBoundary(geojson.id, false)
        this.setState({
            hovered:false,
        })
    }

    handleChange = (event) => {
        if(event.target.value === -1){
            this.props.addFilterPresetCallback();
            return;
        }

        let obj = event.target.value;
        if(obj.hasOwnProperty("filters") && obj.hasOwnProperty("geojson")){
            this.props.setAreaCallback({type: "geojson_filter_preset", data: obj})
        }else {
            this.props.setAreaCallback({type:"area", data:event.target.value});
        }

    }

    testFunc = (value) => {
            if(value){
                return value.name
            }
            return "No area selected"
    }
    render() {
        const ITEM_HEIGHT = 48;
        const ITEM_PADDING_TOP = 8;
        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                },
            },
        };


        return (
            <div>
                <FormControl style={{width:"100%"}}>
                    <Select
                        value={this.props.selectedArea ? this.props.selectedArea.data: null}
                        IconComponent={KeyboardArrowDownIcon}
                        onChange={this.handleChange}
                        MenuProps={MenuProps}
                        displayEmpty
                        renderValue={this.testFunc}
                    >

                        {this.props.geojsons
                            .filter(f => f.active)
                            .map(area => (
                            <MenuItem
                                onMouseEnter={()=>this.highlight(area)}
                                onMouseLeave={()=>this.lowlight(area)}
                                key={area}
                                value={area}>
                                {area.name}
                            </MenuItem>

                        ))}
                        {this.props.allows_filter !== false && [
                                <Divider/>,
                                <ListSubheader>
                                Spatial Filters
                                </ListSubheader>,
                                this.props.geojson_filter_presets.map(f => {
                                        return <MenuItem value={f}>
                                        {f.name}
                                        </MenuItem>
                                }),
                                <MenuItem value={-1}>
                                <ListItemIcon>
                                <AddIcon fontSize={"small"}/>
                                </ListItemIcon>
                                add filter presets
                                </MenuItem>
                        ]
                        }
                    </Select>
                </FormControl>
            </div>

        )
    }
}

GeoJSONSelector.propTypes = {
    addFilterPresetCallback: PropTypes.func,
    allows_filter: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        highlightBoundary: (id, state) => {
            dispatch(highlightGeojson(id, state))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoJSONSelector);
